import { render, staticRenderFns } from "./edit-order.vue?vue&type=template&id=6583a820&"
import script from "./edit-order.vue?vue&type=script&lang=js&"
export * from "./edit-order.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports